import { TableColumnHeader } from "@/components/shared/table/Table";
import { Button } from "@/components/ui/button";
import { convertBpToDecimal, formatDateLocale } from "@/utils/helpers";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { TrashIcon } from "lucide-react";
import { IntlShape } from "react-intl";
import { LiabilityInsurance } from "@/graphql/__generated__/graphql";

export const getColumnsLiabilityInsurance = (
  intl: IntlShape,
  t: TFunction,
  handleRemoveLiabilityInsurance: (_liabilityInsurance: LiabilityInsurance) => void,
  isConfigAdmin: boolean,
): ColumnDef<LiabilityInsurance>[] => [
  {
    id: "activeFrom",
    accessorKey: "activeFrom",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:liabilityinsurance.columns.activationdate")}
        column={column}
      />
    ),
    cell: ({ row }) => {
      const date = new Date(row.getValue("activeFrom"));
      return <div>{formatDateLocale(intl, date)}</div>;
    }
  },
  {
    id: "liabilityInsurance",
    accessorKey: "liabilityInsurance",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:liabilityinsurance.columns.liabilityinsurance")}
        column={column}
        align="end"
      />
    ),
    cell: ({ row }) => {
      const value = parseFloat(row.getValue("liabilityInsurance"));
      return <div className="text-right font-medium">{convertBpToDecimal(value)}%</div>;
    }
  },
  {
    id: "professionalAssociation",
    accessorKey: "professionalAssociation",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:liabilityinsurance.columns.professionalassociation")}
        column={column}
        align="end"
      />
    ),
    cell: ({ row }) => {
      const value = parseFloat(row.getValue("professionalAssociation"));
      return <div className="text-right font-medium">{convertBpToDecimal(value)}%</div>;
    }
  },
  ...(isConfigAdmin
    ? [
      {
        accessorKey: "actions",
        size: 60,
        minSize: 60,
        maxSize: 80,
        header: () => <div></div>,
        cell: ({ row }) => (
          <div className="flex gap-2 justify-end">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleRemoveLiabilityInsurance(row.original)}
            >
              <TrashIcon className="w-4 h-4 text-red-500" />
            </Button>
          </div>
        ),
      },
    ]
    : []),
];
